import { Box, Divider } from '@mui/material';
import * as Preact from 'preact';
import { Basket } from './C_BasketView';
import * as BasketList from './M_BasketList';
import * as BasketTotal from './M_BasketTotal';

export interface Props {
    basket: Basket;
    onAddToBasket?: () => void;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <BasketList.Component
                basketItems={p.basket.items}
                sx={{
                    overflowY: 'auto',
                    height: '100%',
                }}
            />
            <Divider />
            <BasketTotal.Component
                price={p.basket.total}
                originalPrice={p.basket.originalTotal}
                onAddToBasket={p.onAddToBasket}
            />
        </Box>
    );
};

Component.displayName = 'BasketCheckout';
